export { FocusTrap, type FocusTrapProps } from './focus-trap';
